import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from "@angular/router";
import {AppConstants} from "../../../shared/constants/app-constant";
import {EnquiryService} from "../../../shared/services/enquiry.service";
import {AlertService} from "../../../shared/services/alert.service";
import {ModalService} from '../../../shared/services/modal.service';
import {SnotifyService} from 'ng-snotify';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
    @Input() showLimitedFields: boolean = false;
    @Output() formSubmitted = new EventEmitter<boolean>();
    message: string = ''
    messageType: 'success' | 'error' | ''
    submitted: any = false;
    enquiryForm!: FormGroup;
    selectedCourse: any = null;
    constructor(private fb: FormBuilder, public router: Router,private enquiryService: EnquiryService, private alertService : AlertService, private modalService : ModalService)
     {

         this.enquiryForm = this.fb.group({
            fullName: ['', Validators.required],
            contact: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            issues: [''],
            message: [''],
            organisation_name: [''],

        });
    }

    ngOnInit() {

    }

    showMessage(type: 'success' | 'error', text: string) {
        this.messageType = type;
        this.message = text;

        setTimeout(() => {
            this.message = '';
            this.messageType = '';
        }, 5000);
    }
    onSubmit() {
        this.submitted = true;
        if (!this.enquiryForm.valid) {
            return;
        }
        if (this.submitted ) {
            const params = {
                name: this.enquiryForm?.getRawValue()?.fullName || '',
                email: this.enquiryForm?.getRawValue()?.email || '',
                contact: this.enquiryForm?.getRawValue()?.contact || '',
                issues: this.enquiryForm?.getRawValue()?.issues || '',
                message: this.enquiryForm?.getRawValue()?.message || '',
                organisation_name: this.enquiryForm?.getRawValue()?.organisation_name || '',
            };

            this.enquiryService.add(params).subscribe(data => {
                    console.log(data);
                    this.formSubmitted.emit(true);
                    this.modalService.closeModal();
                    this.enquiryForm.reset();
                    this.submitted = false;
                    this.showMessage('success', 'Form submitted successfully!');
                },
                error => {
                    console.error('Error occurred:', error);
                    if (error?.error?.errors && error.error.hasOwnProperty('errors')) {
                        const fieldErrors = error.error.errors;

                        if (fieldErrors.email?.length) {
                            this.showMessage('error', fieldErrors.email[0]);
                            return;
                        }
                        if (fieldErrors.name?.length) {
                            this.showMessage('error', fieldErrors.name[0]);
                            return;
                        }
                        if (fieldErrors.contact?.length) {
                            this.showMessage('error', fieldErrors.contact[0]);
                            return;
                        }
                        if (fieldErrors.issues?.length) {
                            this.showMessage('error', fieldErrors.issues[0]);
                            return;
                        }
                        if (fieldErrors.organisation_name?.length) {
                            this.showMessage('error', fieldErrors.organisation_name[0]);

                            return;
                        }
                        if (fieldErrors.message?.length) {
                            this.showMessage('error', fieldErrors.message[0]);

                            return;
                        }
                    }
                    this.alertService.showErrors('An error occurred. Please check your input and try again.');

            });

        }


    }
}
